<template>
  <div class="popup_container popup-message__container" :class="classwrapper" style="display: none;">
    <div class="popup_head">
      <slot name="header"></slot>
    </div>
    <div class="popup_cont">
      <slot></slot>
    </div>
    <div class="popup_bottom_bl">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name    : "Popup",
  props   : {
    autoopen : {
      type    : Boolean,
      default : false,
    },
    title    : {
      type    : String,
      default : "",
    },
    classwrapper : {
      type    : String,
      default : "",
    }
  },
  data    : () => ( {
    fancybox       : null,
    promiseResolve : null,
  } ),
  mounted()
    {
      if( !this.$el.id )
        {
          this.$el.id=Math.random().toString(36).substring(7);
        }
      if( this.autoopen )
        {
          let testReadyState=setInterval(() =>
          {
            if( document.readyState === "complete" )
              {
                this.open();
                clearInterval(testReadyState);
              }
          }, 500);
        }
    },
  methods : {
    open()
      {
        return new Promise(( resolve, reject ) =>
        {
          this.promiseResolve=resolve;
          this.fancybox      =$.fancybox({
            href       : `#${this.$el.id}`,
            beforeShow : () =>
              {
                $("body").addClass("fancybox-active");
                $("body").addClass("fancy-active");
              },
            afterShow  : () =>
              {
                if( $("body").hasClass("mobile") )
                  {
                    window.scrollTo(0, 0);
                  }
                this.$emit("open");
              },
            afterClose : () =>
              {
                $("body").removeClass("fancybox-active");
                $("body").removeClass("fancy-active");
                this.$emit("close");
              },
          });
        });
      },
    close()
      {
        $.fancybox.close();
      },
    confirm()
      {
        this.promiseResolve("confirm");
        this.$emit("confirm");
        this.close();
      },
    decline()
      {
        console.log(this,'refs');
        this.promiseResolve("decline");
        this.$emit("decline");
        this.close();
      },
  },
};
</script>
